module.exports = __webpack_public_path__ + "static/img/logo_03.605215f5.png";